import { Form } from "antd"
import { type FormInstance } from "antd/es/form/hooks/useForm"
import React, { type Ref } from "react"

import { DocumentCard } from "../DocumentCard.tsx"
import type {
  DocumentFormData,
  DocumentScopeSectionProjectTypes
} from "../document.types.ts"
import {
  DocumentScopeSectionList,
  type DocumentScopeSectionListRef
} from "./DocumentScopeSectionList.tsx"

interface DocumentScopeSectionProps {
  form: FormInstance<DocumentFormData>
  listRef: Ref<DocumentScopeSectionListRef>
  projectTypes: DocumentScopeSectionProjectTypes
}

export function DocumentScopeSection({
  form,
  listRef,
  projectTypes
}: DocumentScopeSectionProps) {
  const columnKey: keyof DocumentFormData = "project_phases"

  return (
    <DocumentCard title={"Detailed Scope of Work"} name={columnKey}>
      {/*<Form.Item name={["detailedScope", "description"]} label="Info">*/}
      {/*  <TextInput placeholder="All work to be performed according to industry standards and California Building Code." />*/}
      {/*</Form.Item>*/}
      <Form.List name={columnKey}>
        {(fields, operations) => (
          <DocumentScopeSectionList
            form={form}
            listRef={listRef}
            fields={fields}
            columnKey={columnKey}
            operations={operations}
            projectTypes={projectTypes}
          />
        )}
      </Form.List>
    </DocumentCard>
  )
}
